import type { FaireProductEntity } from "../../entity_types/product";

export const p_5ec6dw5b2y: FaireProductEntity = {
  token: "p_5ec6dw5b2y",
  type: "product",
  name: "Baseball Mom Social Club Vintage Trucker Hat",
  brandToken: "b_wfq3tnmz7w",
  brandName: "Made by Mariah",
  imageUrl:
    "https://cdn.faire.com/fastly/efb04bd1da7646348309277dc717527b220fe1d6c89508050b5d25d8d1d54fe4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/38aa4c3d5dad48a89aeab544c6c4cb7d4a845ad3cfad80c09c16f287da7515cb.jpeg",
    "https://cdn.faire.com/fastly/d44c1f3d98faa1e058d6bb8e59b9241cc8e1ac7a784438b3a77d94e2318abc18.jpeg",
    "https://cdn.faire.com/fastly/482d63f1fc4f38cafc54daa58247dbfefa69a6cb09dfc0b4c994518bf61b067e.jpeg",
    "https://cdn.faire.com/fastly/11b88296ef9032476fe2bdf946c21ab53aa042b9ee3cc7e9d2a83d64608b4656.jpeg",
    "https://cdn.faire.com/fastly/4170944e0fe9d5502bba28a3fe2051b8554d663c9302f392f015093ea58dc8d7.jpeg",
  ],
  priceDollars: 17.5,
  description:
    "Red/Natural Vintage Trucker Hat with Red/Black embroidered design!\n\n*Message me to customize colors*",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:20.651Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
